var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[
    _vm.iconClass,
    ("icon-container--" + _vm.variant),
    ("icon-container--" + _vm.size),
    {
      'mr-1': _vm.marginRight,
      'cursor-pointer': _vm.clickable,
    } ],on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }